var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9346E2D1-52B7-46FE-B1C2-714EC0EFC373") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Manager-|-My-Account",
    transform: "translate(-1155.000000, -223.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(333.000000, 124.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(822.000000, 99.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7792208,0 L13.4415584,0 L6.6038961,6.83766234 C5.59090909,7.85064935 5,9.2012987 5,10.6363636 L5,13 L7.36363636,13 C8.7987013,13 10.1493506,12.4090909 11.1623377,11.3961039 L18,4.55844156 L18,4.22077922 C18,3.12337662 17.5779221,2.02597403 16.7337662,1.18181818 C15.974026,0.506493506 14.8766234,0 13.7792208,0 L13.7792208,0 Z M9.98051948,10.2987013 C9.30519481,10.974026 8.37662338,11.3961039 7.36363636,11.3961039 L6.68831169,11.3961039 L6.68831169,10.7207792 C6.68831169,9.70779221 7.11038961,8.77922078 7.78571429,8.1038961 L14.1168831,1.77272727 C14.7077922,1.85714286 15.2142857,2.11038961 15.5519481,2.53246753 C15.974026,2.95454545 16.2272727,3.46103896 16.3116883,3.96753247 L9.98051948,10.2987013 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.86813187,18 L12.1318681,18 C13.1868132,18 14.1538462,17.5604396 14.8571429,16.8571429 C15.5604396,16.1538462 16,15.1868132 16,14.1318681 L16,11.4945055 L14.2417582,11.4945055 L14.2417582,14.1318681 C14.2417582,14.6593407 14.0659341,15.1868132 13.6263736,15.6263736 C13.2747253,15.978022 12.7472527,16.2417582 12.1318681,16.2417582 L3.86813187,16.2417582 C3.34065934,16.2417582 2.81318681,16.0659341 2.37362637,15.6263736 C1.93406593,15.1868132 1.75824176,14.7472527 1.75824176,14.1318681 L1.75824176,5.86813187 C1.75824176,5.34065934 1.93406593,4.81318681 2.37362637,4.37362637 C2.72527473,4.02197802 3.25274725,3.75824176 3.86813187,3.75824176 L6.50549451,3.75824176 L6.50549451,2 L3.86813187,2 C2.81318681,2 1.84615385,2.43956044 1.14285714,3.14285714 C0.43956044,3.84615385 0,4.81318681 0,5.86813187 L0,14.1318681 C0,15.1868132 0.43956044,16.1538462 1.14285714,16.8571429 C1.84615385,17.5604396 2.81318681,18 3.86813187,18 L3.86813187,18 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.4630f728b5a1f6cee7b81b7eb1563c0c.svg";
export { ForwardRef as ReactComponent };